import { render, staticRenderFns } from "./ShippoAddress.vue?vue&type=template&id=6257bacb&"
import script from "./ShippoAddress.vue?vue&type=script&lang=ts&"
export * from "./ShippoAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports